import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useSetNextPath = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const setNextPath = useCallback((redirectTo: string, newSearchParams: URLSearchParams) => {
    const search = newSearchParams.size ? `?${newSearchParams.toString()}` : '';
    navigate({
      pathname: location.pathname,
      search,
      hash: location.hash,
    }, { state: { nextPathname: redirectTo }, replace: true });
  }, [location, navigate]);

  return setNextPath;
};

const useNextPath = () => {
  const location = useLocation();
  const pathName = location.state?.nextPathname;
  const search = location.state?.nextSearch;
  const redirectTo = pathName ? `${pathName}${search ?? ''}` : undefined;
  return redirectTo;
};

export default useNextPath;
